import { render, staticRenderFns } from "./intracommodity.vue?vue&type=template&id=5c83a6e4&"
import script from "./intracommodity.vue?vue&type=script&lang=js&"
export * from "./intracommodity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports